const fs = require('fs')
import m from 'mithril';
import {trans, has_permission, has_role, get_person_display_name} from "./helpers";

import Typeahead from './typeaheadComponent.js';
import SelectTypeahead from './selectTypeaheadComponent.js';

const faVideoPlay = fs.readFileSync('css/icons/video-play.svg', 'utf-8');
// const faCheck = fs.readFileSync('css/icons/check-solid.svg', 'utf-8');
const faVerified = fs.readFileSync('css/icons/ijf_verified_badge.svg', 'utf-8');
const faRejectedEntry = fs.readFileSync('css/icons/ban-solid.svg', 'utf-8');
const faChevronLeft = fs.readFileSync('css/icons/chevron-left-solid.svg', 'utf-8');
const faAwardChallengeJudoFit = fs.readFileSync('css/awards/Fit_Award_Challenge_Judo_Fit.svg', 'utf-8');
const faAwardChallengeBronzeFit = fs.readFileSync('css/awards/Fit_Award_Challenge_Bronze_Fit.svg', 'utf-8');
const faAwardChallengeSliverFit = fs.readFileSync('css/awards/Fit_Award_Challenge_Silver_Fit.svg', 'utf-8');
const faAwardChallengeGoldFit = fs.readFileSync('css/awards/Fit_Award_Challenge_Gold_Fit.svg', 'utf-8');
const faThrash = fs.readFileSync('css/icons/thrash.svg', 'utf-8');

let challenge_state = {
    challenge : null,
    loaded: false,
    bg_img : null,
    did_consent : false,
    age_categories : [],
    id_user: (SPORTNETXPAGE.USER && SPORTNETXPAGE.USER.id_user) ? SPORTNETXPAGE.USER.id_user : null,
    user_has_roles: false,
    current_organization: null,
    reports : [],
    reports_loaded : false,
    challenge_not_started : false,
    challenge_has_ended : false,
    challenge_is_active : true,
    target_user_type: "self", // [self, other]
    user : {
        id_user : false,
        has_gender : false,
        has_weight : false,
        has_age_category : false
    },
    group: {
        id_organization_group : 0
    },
    entry_user : {
        list: []
    },
    entry_group : {
        list: []
    },
    leaderboards : {
        status : 'none',
        list : []
    },
    user_leaderboards : {
        status : 'none',
        editing : false,
        list : []
    },
    user_achievements: {
        status: 'none',
        list: [] 
    },
    my_entries : {
        page: 1,
        limit: 10,
        load_more: false,
        status : 'none',
        list : [],
        editing : false
    },
    new_entry : {
        id_video : false,
        // use : 0,
        'public' : 1,
        entry : {},
        status : 'none'
    },
    video_status: {
        file : null,
        status: 'none',
        upload_progress: 0,
        name: false
    },
    groups : {
        status: 'none',
        list: []
    },
    user_rankings: null,
    creating_group: false,
    creating_person: false,
    new_group: {
        title: '',
        users: []
    },
    new_person: {
        first_name: '',
        last_name: ''
    },
    available_organizations: [],
    selected_organizations: {
        list: []
    },

    admin_entries: {
        page: 1,
        limit: 10,
        load_more: false,
        status: 'none',
        list: [],
        selected_organizations: {
            list: []
        }
    },

    all_entries: {
        page: 1,
        limit: 10,
        load_more: false,
        status: 'none',
        list: [],
        selected_organizations: {
            list: []
        }
    },

    must_select_target_user_type: false,

    entry_inserted: false,
    entry_error: false,
    entry_error_msg: '',

    sending_public_challenge_request: false,
    can_request_public_challenge: false,
    public_challenge_requested: false
}

window.challenge_state = challenge_state;

function goBack() {
    window.history.back();
}

class Loading{
    view(){
        return [
            m("div.page-header",
                [
                    m("div.page-header__background"),
                    m("div.page-header__content",
                        m("div.page-header__page-title",
                            trans('challenge.loading')
                        )
                    )
                ]
            ),
            m("div.main-content.main-content--with-page-header.page--upload",
                // m("div.content-box", trans('challenge.loading') + '...')
                m("div.content-box", m('.general-loader', ''))
            )
        ]
    }
}

class ExercisesTemplates {
    oncreate() {
        SPORTNETXPAGE.MODALCOMPONENT();
    }

    view() {
        return challenge_state.challenge.exercises.map(_ex => {
            return m('div.exercise-modal', 
                {
                    id: "modalExercise_"+_ex.id_exercise,
                    style: "display: none"
                },
                [   
                    m('h2', _ex.title),
                    m('.exercise-content', [
                        m.trust(_ex.content)
                    ]),
                    m('a.btn.btn--main.exercise-btn', {
                        href : '/exercise/view/' + _ex.slug,
                        target : '_blank'
                    }, trans('challenge.go_to_exercise_btn'))
                ]
            )
        });
    }
}


class ChallengeExercises {
    view() {
        let already_reported = false;

        let is_rejected = parseInt(challenge_state.challenge.rejected) == 1 ? true : false;
        let is_ijf = parseInt(challenge_state.challenge.is_ijf) == 1 ? true : false;

        if (challenge_state.id_user)
            already_reported = challenge_state.reports.filter(r => r.id_user == challenge_state.id_user).length > 0;

        // console.log(SPORTNETXPAGE.USER, already_reported, is_rejected)

        return [
            m('div.challenge-info__exercises',  
                m('h2.content-box__title', trans('challenge.exercises_in_challenge')),
                m('div.exercises', challenge_state.challenge.exercises.map(_ex => {
                    let _class = '.exercises__split';
                    let is_included = challenge_state
                        .challenge
                        .exercises
                        .filter(_ex1 => _ex1.id_exercise == _ex.id_exercise).length > 0
                    let _ex_obj = null;

                    if(is_included){
                        _class += '.exercises__split--included'
                        for(let _ex_ii of challenge_state.challenge.exercises){
                            if(_ex_ii.id_exercise == _ex.id_exercise){
                                _ex_obj = _ex_ii;
                                if(!_ex_obj['type']){
                                    _ex_obj['type'] = 'repetitions'
                                    _ex_obj['val'] = 1
                                }
                            }
                        }
                    }
                    // return m('a' + _class, {
                    return m('div' + _class, {
                        'data-open-modal': "modalExercise_" + _ex.id_exercise
                        // href : '/exercise/view/' + _ex.slug,
                        // target : '_blank'
                    },[
                        m('div.exercises__img', {
                            style: 'background-image: url("' + _ex.url_poster + '")'
                        }),
                        m('div.exercises__rest', [
                            m('div.exercises__title', _ex.title),
                            m('div.exercises__desc', _ex.short_description),
                        ]),
                    ])
                })),
            ),
            m('div.challenge-info__description',
                // m('h2.content-box__title', trans('challenge.challenge')),
                m('.admin-title', [
                    m('h2.content-box__title', [
                        trans('challenge.challenge'),
                    ]),
                    m('a.btn', {href: '/docs/oddaja-rezultata%20-v-aplikaciji-Navodila.pdf', target: "_blank" }, 'Kako sodelovati?'),
                ]),
                // challenge_state.challenge.description && m('div.description__text', challenge_state.challenge.description),
                m(ChallengeDescriptionShort),


                // (SPORTNETXPAGE.USER && !already_reported && !is_rejected && !is_ijf) &&
                // m('.report-challenge', [
                //     m('.btn.btn--main', {
                //         onclick: e => report_challenge(e)
                //     }, trans('challenge.report'))
                // ]),

                // (SPORTNETXPAGE.USER && is_rejected && challenge_state.id_user == challenge_state.challenge.id_user) &&
                // m('.report-challenge', [
                //     m('.already_reported', trans('challenge.your_entry_rejected'))
                // ]),                

                // (SPORTNETXPAGE.USER && already_reported && challenge_state.id_user != challenge_state.challenge.id_user) &&
                // m('.report-challenge', [
                //     m('.already_reported', trans('challenge.you_reported_msg'))
                // ]),
            ),
            m(ExercisesTemplates)
        ]
    }
}

// class ChallengeStartsEndsInfo {
//     view() {

//         return [
//             (challenge_state.challenge.starts_at) &&
//             m('.challenge-info__sports', [
//                 m('h2.content-box__title', trans('challenge.form.starts_at') + ': ' + challenge_state.challenge.starts_at),
//             ]),

//             (challenge_state.challenge.ends_at) &&
//             m('.challenge-info__age-group', [
//                 m('h2.content-box__title', trans('challenge.form.ends_at') + ': ' + challenge_state.challenge.ends_at),
//             ])
//         ];
//     }
// }

class ChallengeAdditionalInfo {
    view() {
        let sports_text = challenge_state.challenge.sports.map(s => s.title).join(', ');
        let age_groups_text = challenge_state.challenge.group_items.filter(g => g.group_code == 'ages').map(g => g.title).join(', ');
        
        return [
            (sports_text.length > 0) &&
            m('.challenge-info__sports', [
                m('h2.content-box__title', trans('challenge.suitable_for_sports') + ':'),
                m('.sports', sports_text)
            ]),

            (age_groups_text.length > 0) &&
            m('.challenge-info__age-group', [
                m('h2.content-box__title', trans('challenge.suitable_for_ages') + ':'),
                m('.groups', age_groups_text)
            ])
        ];
    }
}

class ChallengeDescriptionShort{
    view(){

        if (challenge_state.challenge.type_code == 'time_for_x_rep'){
            return m('div.description__short', 
                m('p', trans('challenge.time_for_x_rep_msg.how_much')), 
                m('p.description__short__type', trans('challenge.time_for_x_rep_msg.time')), 
                m('p', trans('challenge.time_for_x_rep_msg.do_you_need_for')),
                m('p.description__short__variable', challenge_state.challenge.data['x']),
                m('p', trans('challenge.time_for_x_rep_msg.repetitions')),
                m('p','?'),
            )
        } else if(challenge_state.challenge.type_code == 'time_for_completion'){
            return m('div.description__short', 
                m('p', trans('challenge.time_for_completion_msg.how_much')), 
                m('p.description__short__type', trans('challenge.time_for_completion_msg.time')), 
                m('p', trans('challenge.time_for_completion_msg.do_you_need_to_complete_this')),
                m('p.description__short__variable', trans('challenge.time_for_completion_msg.challenge')),
                m('p','?'),
            )
        } else if(challenge_state.challenge.type_code == 'time_max'){
            return m('div.description__short', 
                m('p', trans('challenge.time_max_msg.for_how')), 
                m('p.description__short__type', trans('challenge.time_max_msg.long')), 
                m('p', trans('challenge.time_max_msg.can_you')),
                m('p.description__short__variable', trans('challenge.time_max_msg.go')),
                m('p','?'),
            )            
        } else if(challenge_state.challenge.type_code == 'x_rep_in_y_time'){
            return m('div.description__short', 
                m('p', trans('challenge.x_rep_in_y_time_msg.how_many')), 
                m('p.description__short__type', trans('challenge.x_rep_in_y_time_msg.repetitions')), 
                m('p', trans('challenge.x_rep_in_y_time_msg.can_you_do_in')),
                m('p.description__short__variable', challenge_state.challenge.data['y']),
                m('p', trans('challenge.x_rep_in_y_time_msg.seconds')),
                m('p','?'),
            )
        } else if(challenge_state.challenge.type_code == 'x_succcessful_in_y_time'){
            return m('div.description__short', 
                m('p', trans('challenge.x_succcessful_in_y_time_msg.how_many')), 
                m('p.description__short__type', trans('challenge.x_succcessful_in_y_time_msg.repetitions')), 
                m('p', trans('challenge.x_succcessful_in_y_time_msg.can_you_do_in')),
                m('p.description__short__variable', challenge_state.challenge.data['y']),
                m('p', trans('challenge.x_succcessful_in_y_time_msg.seconds')),
                m('p','?'),
            )
        } else if(challenge_state.challenge.type_code == 'x_rep'){
            return m('div.description__short', 
                m('p', trans('challenge.x_rep_msg.how_many')), 
                m('p.description__short__type', trans('challenge.x_rep_msg.repetitions')), 
                m('p', trans('challenge.x_rep_msg.can_you_do')),
                m('p','?'),
            )
        } else if(challenge_state.challenge.type_code == 'x_result'){
            return m('div.description__short', 
                m('p', trans('challenge.x_result_msg.what_is')), 
                m('p.description__short__type', trans('challenge.x_result_msg.your')), 
                m('p', trans('challenge.x_result_msg.result')),
                m('p','?'),
            )
        } else if(challenge_state.challenge.type_code == 'best_result_in_x_tries'){
            return m('div.description__short', 
                m('p', trans('challenge.best_result_in_x_tries_msg.what_is_your')), 
                m('p.description__short__type', trans('challenge.best_result_in_x_tries_msg.best')), 
                m('p', trans('challenge.best_result_in_x_tries_msg.result_in')),
                m('p.description__short__variable', challenge_state.challenge.data['x']),
                m('p', trans('challenge.best_result_in_x_tries_msg.tries')),
                m('p','?'),
            )
        } else if(challenge_state.challenge.type_code == 'tries_for_x_successful'){
            return m('div.description__short', 
                m('p', trans('challenge.tries_for_x_successful_msg.how_many')), 
                m('p.description__short__type', trans('challenge.tries_for_x_successful_msg.tries')), 
                m('p', trans('challenge.tries_for_x_successful_msg.you_need_for')),
                m('p.description__short__variable', challenge_state.challenge.data['x']),
                m('p', trans('challenge.tries_for_x_successful_msg.successful')),
                m('p','?'),
            )
        } else if(challenge_state.challenge.type_code == 'passed_didnt_pass'){
            return m('div.description__short', 
                m('p', trans('challenge.passed_didnt_pass_msg.can_you')), 
                m('p.description__short__type', trans('challenge.passed_didnt_pass_msg.pass')), 
                m('p', trans('challenge.passed_didnt_pass_msg.this_challenge')),
                m('p','?'),
            )
        } else if(challenge_state.challenge.type_code == 'x_persons_in_successful_group'){
            return m('div.description__short', 
                m('p', trans('challenge.x_persons_in_successful_group_msg.how_many')), 
                m('p.description__short__type', trans('challenge.x_persons_in_successful_group_msg.students')), 
                m('p', trans('challenge.x_persons_in_successful_group_msg.is_in_group_that')),
                m('p.description__short__type', trans('challenge.x_persons_in_successful_group_msg.successfully')),
                m('p', trans('challenge.x_persons_in_successful_group_msg.completes_challenge') + '?'),
            )
        }

        return '';
    }
}

class ChallengeUserEntriesTable {
    load_more(e) {
        challenge_state.my_entries.page = challenge_state.my_entries.page+1;
        challenge_state.my_entries.load_more = false;
        get_challenge_my_entries(false);
    }

    view(){
        let _class = '.table.table--stripped.table--dark-theme';
        if(challenge_state.my_entries.editing){
            _class += '.loading'
        }
        return [
            m('table' + _class, [
                m('thead',
                    m('tr', [
                        (challenge_state.challenge.entry_type_code == 'individual') &&
                        m('th', trans('challenge.user')),
                        
                        (challenge_state.challenge.entry_type_code == 'group') &&
                        m('th', trans('challenge.group')),
                        
                        m('th', trans('challenge.entry')),

                        // m('th', trans('challenge.video')),
                        // m('th', trans('challenge.use_in_ranking')),
                        // m('th', trans('challenge.show') + ':'),
                        m('th', trans('challenge.inserted_by')),
                        m('th', trans('challenge.inserted_at')),
                        m('th', ''),
                    ])),
                m('tbody', challenge_state.my_entries.list.map(_e => {
                    return m('tr', [
                        (challenge_state.challenge.entry_type_code == 'individual') &&
                        // m('td[data-t="User"]', _e.user_first_name + ' ' + _e.user_last_name),
                        m('td[data-t="User"]', get_person_display_name(_e, 'user_first_name', 'user_last_name', 'user_display_name')),

                        (challenge_state.challenge.entry_type_code == 'group') &&
                        m('td[data-t="Group"]', _e.organization_group),
                        
                        _e.rejected == 0 && m('td[data-t="Entry"]', Object.values(_e.entry).filter(_x => _x > 0) ? _e.entry_value : 0),
                        _e.rejected == 1 && m('td[data-t="Entry"].rejected', {
                            title : 'Entry has been rejected'
                        },[
                            Object.values(_e.entry).filter(_x => _x > 0) ? _e.entry_value : 0,
                            m.trust(faRejectedEntry)
                        ]),

                        
                        // _e.id_video &&
                        // m('td[data-t="Video"]', m('a.pointer.fa--main-color.icon', {href: "/entries/view/" + _e.id_entry}, m.trust(faVideoPlay))),
                        // !_e.id_video &&
                        // m('td[data-t="Video"]', trans('challenge.no_video')),
                        
                        // _e.id_video && m('td[data-t="Use in ranking?"]', [
                        // m('td[data-t="Use in ranking?"]', [
                        //     _e.use == 1 &&
                        //     m('div.icon', [
                        //         m('svg.svg-inline--fa.fa-check-square.fa-w-14', {
                        //             'aria-hidden': "true",
                        //             focusable: "false",
                        //             'data-prefix': "far",
                        //             'data-icon': "check-square",
                        //             role: "img",
                        //             xmlns: "http://www.w3.org/2000/svg",
                        //             viewBox: "0 0 448 512"
                        //         }, [
                        //             m('title', trans('challenge.this_one_is_used')),
                        //             m('path', {fill: "currentColor", d: "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm0 400H48V80h352v352zm-35.864-241.724L191.547 361.48c-4.705 4.667-12.303 4.637-16.97-.068l-90.781-91.516c-4.667-4.705-4.637-12.303.069-16.971l22.719-22.536c4.705-4.667 12.303-4.637 16.97.069l59.792 60.277 141.352-140.216c4.705-4.667 12.303-4.637 16.97.068l22.536 22.718c4.667 4.706 4.637 12.304-.068 16.971z"})
                        //         ]) 
                        //     ]),

                        //     _e.use == 0 &&
                        //     m('div.icon', [
                        //         m('svg.svg-inline--fa.fa-square.fa-w-14', {
                        //             'aria-hidden': "true",
                        //             focusable: "false",
                        //             'data-prefix': "far",
                        //             'data-icon': "square",
                        //             role: "img",
                        //             xmlns: "http://www.w3.org/2000/svg",
                        //             viewBox: "0 0 448 512",
                        //             onclick : function(){
                        //                 _e.public = 1;
                        //                 update_entry({
                        //                     id_entry : _e.id_entry,
                        //                     use : _e.use == 1 ? 0 : 1,
                        //                     public : 1
                        //                 })

                        //                 alert(trans('challenge.ranking_reminder'));
                        //             },
                        //         }, [
                        //             m('title', trans('challenge.use_this')),
                        //             m('path', {fill: "currentColor", d: "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h340c3.3 0 6 2.7 6 6v340c0 3.3-2.7 6-6 6z"})
                        //         ]) 
                        //     ])

                        // ]),
                        // // !_e.id_video && m('td[data-t="Use in ranking?"]', m('small', 'Cannot use in ranking')),
                        // m('td[data-t="Show:"]', [
                        //     _e.public == 1 &&
                        //     m('div.icon', [
                        //         m('svg.svg-inline--fa.fa-check-square.fa-w-14', {
                        //             'aria-hidden': "true",
                        //             focusable: "false",
                        //             'data-prefix': "far",
                        //             'data-icon': "check-square",
                        //             role: "img",
                        //             xmlns: "http://www.w3.org/2000/svg",
                        //             viewBox: "0 0 448 512",
                        //             onclick : function(){
                        //                 if (_e.use == 1) {
                        //                     alert(trans('challenge.cannot_hide'));
                        //                     return;
                        //                 }
                        //                 update_entry({
                        //                     id_entry : _e.id_entry,
                        //                     public : _e.public == 1 ? 0 : 1
                        //                 })
                        //             }
                        //         }, [
                        //             m('path', {fill: "currentColor", d: "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm0 400H48V80h352v352zm-35.864-241.724L191.547 361.48c-4.705 4.667-12.303 4.637-16.97-.068l-90.781-91.516c-4.667-4.705-4.637-12.303.069-16.971l22.719-22.536c4.705-4.667 12.303-4.637 16.97.069l59.792 60.277 141.352-140.216c4.705-4.667 12.303-4.637 16.97.068l22.536 22.718c4.667 4.706 4.637 12.304-.068 16.971z"})
                        //         ])
                        //     ]),

                        //     _e.public == 0 &&
                        //     m('div.icon', [
                        //         m('svg.svg-inline--fa.fa-square.fa-w-14', {
                        //             'aria-hidden': "true",
                        //             focusable: "false",
                        //             'data-prefix': "far",
                        //             'data-icon': "square",
                        //             role: "img",
                        //             xmlns: "http://www.w3.org/2000/svg",
                        //             viewBox: "0 0 448 512",
                        //             onclick : function(){
                        //                 if (_e.use == 1) {
                        //                     alert(trans('challenge.cannot_hide'));
                        //                     return;
                        //                 }
                        //                 update_entry({
                        //                     id_entry : _e.id_entry,
                        //                     public : _e.public == 1 ? 0 : 1
                        //                 });
                        //             },
                        //         }, [
                        //             m('path', {fill: "currentColor", d: "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h340c3.3 0 6 2.7 6 6v340c0 3.3-2.7 6-6 6z"})
                        //         ])
                        //     ]),
                        // ]),
                        m('td[data-t="Inserted by"]', _e.inserted_by_first_name + ' ' + _e.inserted_by_last_name),
                        m('td[data-t="Inserted at"]', new Date(_e.inserted_at).toLocaleDateString("sl-SI")),
                        m('td[data-t="Options"].pointer', m('div.icon', [
                            (challenge_state.id_user*1 == _e.inserted_by*1 || has_permission('challenges.canInsertEntryToAnyone')) &&
                            m('svg.svg-inline--fa.fa-trash-alt.fa-w-14', {
                                'aria-hidden': "true",
                                focusable: "false",
                                'data-prefix': "far",
                                'data-icon': "trash-alt",
                                role: "img",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 448 512",
                                onclick : function(){
                                    delete_entry({
                                        id_entry : _e.id_entry
                                    })
                                }
                            }, [
                                m('title', trans('challenge.delete')),
                                m('path', {fill: "currentColor", d: "M268 416h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12zM432 80h-82.41l-34-56.7A48 48 0 0 0 274.41 0H173.59a48 48 0 0 0-41.16 23.3L98.41 80H16A16 16 0 0 0 0 96v16a16 16 0 0 0 16 16h16v336a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128h16a16 16 0 0 0 16-16V96a16 16 0 0 0-16-16zM171.84 50.91A6 6 0 0 1 177 48h94a6 6 0 0 1 5.15 2.91L293.61 80H154.39zM368 464H80V128h288zm-212-48h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12z"})
                            ])
                        ]))
                    ])
                }))
            ]),

            (challenge_state.my_entries.load_more && !challenge_state.my_entries.status != 'loading') &&
            m('.btn.btn--small.btn--full-width.load-more', { 
                onclick: e => this.load_more(e)
            }, trans('common.load_more')),
        ];
    }
}

class ChallengeUserEntries{
    view(){
        if(challenge_state.my_entries.status != 'loaded'){
            return '';
        }
        return m('div.your_entries', [
            challenge_state.my_entries.list.length == 0 && m('b', trans('challenge.no_results_yet')),
            challenge_state.my_entries.list.length > 0 && m(ChallengeUserEntriesTable),
            
            // m('div.your_entries__info', trans('challenge.entries_with_video_ranking')),

            // m('div.your_entries__info', [
            //     m('strong', trans('challenge.use_ranking')),
            //     ' ' + trans('challenge.best_result')
            // ]),

            // m('div.your_entries__info', [
            //     m('strong', trans('challenge.show_hide') + ': '),
            //     trans('challenge.hide_entry')
            // ])
        ])
    }
}

class AddEntryFormDataPubPriv {
    view() {
        return m('select', {
            onchange : _dom => challenge_state.new_entry.public = _dom.target.value,
            value : challenge_state.new_entry.public
        },[
            m('option', {
                value : 1
            }, trans('challenge.public')),
            m('option', {
                value : 0
            }, trans('challenge.private'))
        ])
    }
}

class AddEntryFormGroup {
    editGroup() {
        if (challenge_state.entry_group.list.length == 0)
            return;

        let organization_group = challenge_state.entry_group.list[0];

        get_organizations_group(organization_group.id_organization_group);
    }

    view() {
        return [
            m('.ijf-form', [
                m('.line', [
                    m('.line-element', [
                        m(SelectTypeahead, {
                            listMode: true,
                            list: challenge_state.groups,
                            selectedItems: challenge_state.entry_group, // must be object with 'list' atribute (see function: get_groups())
                            placeholder: trans('challenge.select_organization_group_placeholder'),
                            noResultsText: trans('common.no_results'),
                            getItemText: g => g.title,
                            getItemId: g => g.id_organization_group,
                            type: 'radio',
                            onChange: _ => {
                                challenge_state.creating_group = false;
                                challenge_state.editing_group = false;
                            }
                        }),

                        m('.label-container', [
                            m('.label-container__label', [
                                trans('challenge.organization_group_not_on_list_text') + '? ',
                                m('a.link', {
                                    href: "#",
                                    onclick: e => {
                                       e.preventDefault();
                                       reset_new_group_form();
                                       challenge_state.creating_group = true;
                                       challenge_state.editing_group = false;
                                       challenge_state.creating_person = false;
                                    } 
                                }, trans('challenge.add_new_organization_group')),
                            ]),
                        ]),

                        (challenge_state.entry_group.list.length > 0) &&
                        m('.label-container', [
                            m('.label-container__label', [
                                m('a.link', {
                                    href: "#",
                                    onclick: e => {
                                       e.preventDefault();
                                       // reset_new_group_form();
                                       challenge_state.editing_group = true;
                                       challenge_state.creating_group = false;
                                       challenge_state.creating_person = false;
                                       this.editGroup();
                                    } 
                                }, trans('challenge.edit_organization_group')),
                            ]),
                        ])
                    ])
                ]),
            ]),

            (challenge_state.creating_group || challenge_state.editing_group) &&
            m(GroupCreator),

            // (challenge_state.group.id_organization_group > 0) &&
            (challenge_state.entry_group.list.length > 0) &&
            m(AddEntryFormData)
        ];
    }
}


class UserSelector {
    oninit(vnode) {
        this.type = vnode.attrs.type;

        if (!this.type)
            this.type = 'checkbox';
    }

    getUsers(query, data_state) {
        if (!challenge_state.current_organization) {
            console.error("ORGANIZATION NOT SELECTED!");
            return;
        }

        m.request({
            method: "GET",
            // url: "/api/users?my_organization=true&order_by=display_name|asc&query="+query,
            url: "/api/users?id_organization=" + challenge_state.current_organization.id_organization + "&order_by=first_name|asc&query="+query,
        }).then(function(data) {
            data_state.results = data.filter(u => u.id_user != challenge_state.id_user);
            data_state.is_loading = false;

            m.redraw();
        });
    }

    view() {
        return [
            m('.ijf-form', [
                m('.line', [
                    m('.line-element', [
                        // m(Typeahead, { 
                        //     getData: this.getUsers,
                        //     getItemText: user => user.first_name + " " + user.last_name,
                        //     onItemSelect: this.onUserSelected,
                        //     placeholder: trans('challenge.select_user_placeholder'),
                        //     noresultstext: trans('common.no_results')
                        // }),
                        m(SelectTypeahead, {
                            listMode: false,
                            getData: this.getUsers,
                            selectedItems: challenge_state.entry_user, // must be object with 'list' atribute (see function: get_groups())
                            placeholder: trans('challenge.select_user_placeholder'),
                            noResultsText: trans('common.no_results'),
                            getItemText: user => user.first_name + " " + user.last_name,
                            getItemId: user => user.id_user,
                            type: this.type
                        }),

                        has_permission('users.quickInsert') &&
                        m('.label-container', [
                            m('.label-container__label', [
                                trans('challenge.person_not_on_list_text') + '? ',
                                m('a.link', {
                                    href: "#",
                                    onclick: e => {
                                       e.preventDefault();
                                       reset_new_person_form();
                                       challenge_state.creating_person = true;
                                    } 
                                }, trans('challenge.add_new_person')),
                            ]),
                        ])
                    ]),
                ]),
            ]),
        ]
    }
}


class TargetUserTypeSelector {
    // challenge_state.target_user_type
    view() {
        return [
            m('.component--filters', [
                m('.filters-row', [
                    m('.one-filter', [
                        m('.filter-label', trans('challenge.result_is_text')+':'),
                        m('.ButtonsSelect', [
                            m('.opt' + (challenge_state.target_user_type == 'self' ? '.active' : ''), {
                                onclick: e => {
                                    challenge_state.target_user_type = 'self';
                                    challenge_state.creating_person = false;
                                }
                            }, trans('challenge.target_user_type_self_text')),
                            m('.opt' + (challenge_state.target_user_type == 'other' ? '.active' : ''), {
                                onclick: e => {
                                    challenge_state.target_user_type = 'other';
                                    challenge_state.creating_person = false;
                                }
                            }, trans('challenge.target_user_type_other_text')),
                        ])
                    ]),
                ]),
            ]),
            // m('.target-user-type-selector', [
                // m('label', trans('challenge.result_is_text')+':'),
                // m('.target-user-type', [
                //     m('input', {
                //         type: 'radio',
                //         value: 'self',
                //         name: 'target_user_type',
                //         onchange: e => { challenge_state.target_user_type = 'self' }
                //     }),
                //     m('target-user-type__title', [
                //         trans('challenge.target_user_type_self_text'),
                //     ]),
                // ]),
                // m('.target-user-type', [
                //     m('input', {
                //         type: 'radio',
                //         value: 'other',
                //         name: 'target_user_type',
                //         onchange: e => { challenge_state.target_user_type = 'other' }
                //     }),
                //     m('target-user-type__title', [
                //         trans('challenge.target_user_type_other_text'),
                //     ]),
                // ]),
            // ])
        ];
    }
}

class AddEntryFormIndividual {
    oninit() {
        let user_roles = SPORTNETXPAGE.USER_DATA.roles_codes;
        let challenge_roles = challenge_state.challenge.roles.map(role => role.code);

        let user_challenge_roles = user_roles;

        if (challenge_roles.length > 0)
            user_challenge_roles = user_roles.filter(role => challenge_roles.includes(role));

        challenge_state.must_select_target_user_type = (has_role('admin') ||
                                                        user_challenge_roles.includes('panozni') ||
                                                        user_challenge_roles.includes('ucitelj') ||
                                                        user_challenge_roles.includes('klubski_trener') ||
                                                        user_challenge_roles.includes('podrocni'));

        if (challenge_state.must_select_target_user_type) {
            challenge_state.target_user_type = false;            
        }
    }

    view() {
        return [
            challenge_state.must_select_target_user_type &&
            m(TargetUserTypeSelector),

            (challenge_state.target_user_type == 'other') &&
            m(UserSelector, {type: 'radio'}),

            challenge_state.creating_person &&
            m(PersonCreator),

            ((challenge_state.target_user_type == 'self') ||
             (challenge_state.target_user_type == 'other' && challenge_state.entry_user.list.length > 0)) &&
            m(AddEntryFormData)

            // m('div', challenge_state.target_user_type),

            // !challenge_state.must_select_target_user_type &&
            // m('div', 'Kr zame!')            
        ];
    }
}

class AddEntryForm {
    view() {
        return [
            (challenge_state.challenge.entry_type_code == 'group') &&
            m(AddEntryFormGroup),

            challenge_state.challenge.entry_type_code == 'individual' &&
            m(AddEntryFormIndividual)
        ]
    }
}

class AddEntryFormDataInput {
    view() {
        if (challenge_state.challenge.type_code == 'time_for_x_rep'){
            return m('div.challenge_add_entry__data__input', [
                m('div.input-label', trans('challenge.result') + ':'),
                m('input', {
                    size: 4,
                    onchange : _dom => {
                        challenge_state.new_entry.entry['time'] = _dom.target.value
                    },
                    type: 'number'
                    // value : challenge_state.new_entry.entry['time'] || 0
                }),
                m('span.input-unit', ' ' + trans('challenge.seconds')),
            ]);
        } else if (challenge_state.challenge.type_code == 'time_for_completion'){
            return m('div.challenge_add_entry__data__input', [
                m('div.input-label', trans('challenge.result')+':'),
                m('input', {
                    size: 4,
                    onchange : _dom => {
                        challenge_state.new_entry.entry['time'] = _dom.target.value
                    },
                    type: 'number'
                    // value : challenge_state.new_entry.entry['time'] || 0
                }),
                m('span.input-unit', ' ' + trans('challenge.seconds')),
            ]);
        } else if (challenge_state.challenge.type_code == 'time_max'){
            return m('div.challenge_add_entry__data__input', [
                m('div.input-label', trans('challenge.result') + ':'),
                m('input', {
                    size: 4,
                    onchange : _dom => {
                        challenge_state.new_entry.entry['time'] = _dom.target.value
                    },
                    type: 'number'
                    // value : challenge_state.new_entry.entry['time'] || 0
                }),
                m('span.input-unit', ' ' + trans('challenge.seconds')),
            ]);
        } else if (challenge_state.challenge.type_code == 'x_rep_in_y_time'){
            return m('div.challenge_add_entry__data__input', [
                // m('div.input-label', trans('challenge.result') + ':'),
                m('input', {
                    size: 4,
                    onchange : _dom => {
                        challenge_state.new_entry.entry['x'] = _dom.target.value
                    },
                    type: 'number'
                    // value : challenge_state.new_entry.entry['x'] || 0
                }),
                m('span.input-unit', ' ' + trans('challenge.times')),
            ]);
        } else if (challenge_state.challenge.type_code == 'x_succcessful_in_y_time'){
            return m('div.challenge_add_entry__data__input', [
                // m('div.input-label', trans('challenge.result') + ':'),
                m('input', {
                    size: 4,
                    onchange : _dom => {
                        challenge_state.new_entry.entry['x'] = _dom.target.value
                    },
                    type: 'number'
                    // value : challenge_state.new_entry.entry['x'] || 0
                }),
                m('span.input-unit', ' ' + trans('challenge.times')),
            ]);
        } else if (challenge_state.challenge.type_code == 'x_rep'){
            return m('div.challenge_add_entry__data__input', [
                // m('div.input-label', trans('challenge.result') + ':'),
                m('input', {
                    size: 4,
                    onchange : _dom => {
                        challenge_state.new_entry.entry['x'] = _dom.target.value
                    },
                    type: 'number'
                    // value : challenge_state.new_entry.entry['x'] || 0
                }),
                m('span.input-unit', ' ' + trans('challenge.times')),
            ]);
        } else if (challenge_state.challenge.type_code == 'x_result'){
            return m('div.challenge_add_entry__data__input', [
                m('input', {
                    size: 4,
                    onchange : _dom => {
                        challenge_state.new_entry.entry['x'] = _dom.target.value
                    },
                    type: 'number'
                }),
                // m('span.input-unit', ' ' + trans('challenge.times')),
            ]);
        } else if (challenge_state.challenge.type_code == 'best_result_in_x_tries'){
            return m('div.challenge_add_entry__data__input', [
                // m('div.input-label', trans('challenge.result') + ':'),
                m('input', {
                    size: 4,
                    onchange : _dom => {
                        challenge_state.new_entry.entry['x'] = _dom.target.value
                    },
                    type: 'number'
                    // value : challenge_state.new_entry.entry['x'] || 0
                }),
                m('span.input-unit', ' ' + trans('challenge.times')),
            ]);
        } else if (challenge_state.challenge.type_code == 'tries_for_x_successful'){
            return m('div.challenge_add_entry__data__input', [
                // m('div.input-label', trans('challenge.result') + ':'),
                m('input', {
                    size: 4,
                    onchange : _dom => {
                        challenge_state.new_entry.entry['x'] = _dom.target.value
                    },
                    type: 'number'
                    // value : challenge_state.new_entry.entry['x'] || 0
                }),
                m('span.input-unit', ' ' + trans('challenge.tries')),
            ]);
        } else if (challenge_state.challenge.type_code == 'x_persons_in_successful_group'){
            return m('div.challenge_add_entry__data__input', [
                m('input', {
                    size: 4,
                    onchange : _dom => {
                        challenge_state.new_entry.entry['x'] = _dom.target.value
                    },
                    type: 'number'
                }),
                m('span.input-unit', ' ' + trans('challenge.persons')),
            ]);
        } else if (challenge_state.challenge.type_code == 'passed_didnt_pass') {
            // if (!('x' in challenge_state.new_entry.entry)) {
            //     challenge_state.new_entry.entry = {
            //         x: 0
            //     };
            // }

            return m('div.challenge_add_entry__data__input', [
                // m('div.input-label', trans('challenge.result') + ':'),
                m('.component--filters', [
                    m('.filters-row', [
                        m('.one-filter', [
                            m('.ButtonsSelect', [
                                m('.opt' + (challenge_state.new_entry.entry['x'] == 0 ? '.active' : ''), {
                                    onclick: e => {
                                        challenge_state.new_entry.entry['x'] = 0;
                                    }
                                }, trans('challenge.didnt_pass_text')),
                                m('.opt' + (challenge_state.new_entry.entry['x'] == 1 ? '.active' : ''), {
                                    onclick: e => {
                                        challenge_state.new_entry.entry['x'] = 1;
                                    }
                                }, trans('challenge.has_passed_text')),
                            ])
                        ]),
                    ]),
                ]),
            ]);
        }
    }
}

class AddEntryFormData {
    view(){
        let entry_user_name = '';

        if (challenge_state.target_user_type == 'self') {
            entry_user_name = SPORTNETXPAGE.USER_DATA.basic_info.first_name + ' ' + SPORTNETXPAGE.USER_DATA.basic_info.last_name;
        } else if (challenge_state.target_user_type == 'other' && challenge_state.entry_user.list.length > 0) {
            entry_user_name = challenge_state.entry_user.list[0].first_name + ' ' + challenge_state.entry_user.list[0].last_name;
        }

        let entry_group_name = '';
        if (challenge_state.challenge.entry_type_code == 'group' && challenge_state.entry_group.list.length > 0) {
            // let group = challenge_state.groups.list.filter(g => g.id_organization_group == challenge_state.group.id_organization_group);
            let group = challenge_state.entry_group.list[0];
            entry_group_name = group.title;
        }

        return m('div.challenge_add_entry__data', [
            m('div.challenge_add_entry__data__row', [
                challenge_state.challenge.entry_type_code == 'individual' &&
                m('div', trans('challenge.result_for_text') + ' ' + entry_user_name + ':'),
                
                challenge_state.challenge.entry_type_code == 'group' &&
                m('div', trans('challenge.result_for_text') + ' ' + entry_group_name + ':')
            ]),
            m('div.challenge_add_entry__data__row', [
                m(AddEntryFormDataInput),
                // m('div.challenge_add_entry__data__input', [
                //     m('div.input-label', trans('challenge.show') + ':'),
                //     m(AddEntryFormDataPubPriv)
                // ])
            ]),
            // m('div.challenge_add_entry__data__row', [
            //     // (!challenge_state.user.has_age_category) && m(AgeCategories),
            //     // (!challenge_state.user.has_weight) && m(Weight),
            //     // (!challenge_state.user.has_gender) && m(Gender)
            // ])
        ]);
    }
}

class AgeCategories{
    view(){
        return m('div.challenge_add_entry__data__input', [
            m('div.input-label', trans('common.category')+ ':'),
            m('select', {
                    onchange : e => { challenge_state.new_entry.age_category = e.target.value; },
                    value : challenge_state.new_entry.age_category || 0
                }, [
                    m('option', {
                        value : 0,
                    }, trans('common.unspecified')),
                    challenge_state.age_categories.map(ac => {
                        return m('option', {
                            value : ac.id_category,
                        }, ac.title)
                    })
                ]
            )
        ])
    }
}

class Weight{
    view(){
        return m('div.challenge_add_entry__data__input', [
            m('div.input-label', trans('common.weight') + ':'),
            m('input', {
                size: 4,
                value: challenge_state.new_entry.weight || 0,
                onchange : e => {
                    challenge_state.new_entry.weight = e.target.value;
                }
            }),
            m('span.input-unit', ' kg')
        ])
    }
}

class Gender{
    view(){
        return m('div.challenge_add_entry__data__input', [
            m('div.input-label', trans('common.gender')+ ':'),
            m('select', {
                    onchange : e => { challenge_state.new_entry.gender = e.target.value; },
                    value : challenge_state.new_entry.gender || 0
                }, [
                    m('option', {
                        value : 0,
                    }, trans('common.unspecified')),
                    m('option', {value : 'm'}, trans('common.male')),
                    m('option', {value : 'f'}, trans('common.female'))
                ]
            )
        ])
    }
}

class AddEntryContainer {

    view(){
        let btn_class = '.btn--main';

        if (challenge_state.entry_inserted)
            btn_class = '.btn--green';

        if (challenge_state.entry_error)
            btn_class = '.btn--red';

        return m('.challenge_add_entry', [
            m('.challenge_add_entry__container', [
                // m('.challenge_add_entry__timeline','1'),
                m('.challenge_add_entry__subcontainer', [
                    challenge_state.current_organization &&                
                    m('.label-container', [
                        m('.label-container__label', trans('challenge.inserting_for_organization') + ':'),
                        m('.label-container__text', [
                            challenge_state.current_organization.title + '  ',

                            // (challenge_state.available_organizations.length > 1 || challenge_state.available_organizations.length == 0) && // == 0 zero check enables super admin to change organization when challenge has no organization constraints
                            (challenge_state.available_organizations.length > 1 || has_permission('challenges.canInsertEntryToAnyone')) && 
                            [
                                '(',
                                m('a.link', {
                                    href: "#",
                                    onclick: e => {
                                       e.preventDefault();

                                       reset_organization();
                                    } 
                                }, trans('common.change').toLowerCase()),
                                ')'
                            ]
                        ]),
                    ]),           

                    m(AddEntryForm),
                    
                    m('div.challenge_add_entry__save', [
                        m('div.btn.btn--full-width.btn--transition'+btn_class, {
                            onclick: e => add_entry()
                        }, [
                            // (!challenge_state.entry_inserted) &&
                            (!challenge_state.entry_inserted && !challenge_state.entry_error) &&
                            trans('challenge.send_and_join_challenge'),
                            
                            challenge_state.entry_inserted &&
                            trans('challenge.entry_added'),

                            challenge_state.entry_error &&
                            trans('challenge.could_not_insert_entry'),
                        ]),
                        challenge_state.entry_error &&
                        m('div.challenge_add_entry__error', challenge_state.entry_error_msg)
                    ]),

                    // m('div.btn.btn--full-width.btn--green', ),
                ]),

            ]),
               
            // m('div.challenge_add_entry__container', [
            //     m('div.challenge_add_entry__timeline','2'),
            //     m('div.challenge_add_entry__video', [
            //         m('input#fileupload', {
            //             type : 'file',
            //             onchange : function(e){
            //                 // alert('on change') // dbg
            //                 challenge_state.video_status.file = e.target.files[0]
            //                 // uploadVideo()
            //             }
            //         }),
            //         m('div.btn.btn--full-width.btn--main', {
            //             onclick: function(e){
            //                 uploadVideo()
            //             }
            //         }, trans('challenge.upload_video')),
                    
            //         (challenge_state.video_status.status == 'uploading') &&
            //         m('div.progress', [
            //             'Uploading ',
            //             m('div.loader-fileupload'),
            //             challenge_state.video_status.upload_progress + '%'
            //         ]),
                    
            //         (challenge_state.video_status.status == 'finished') &&
            //         m('div.status', trans('challenge.uploaded_video') + ': ' + challenge_state.video_status.name),
            //         m('div.challenge_add_entry__message', trans('challenge.participate_in_ranking_message')),
            //     ]),
            // ]),
            m('div.challenge_add_entry__container', [
                // // m('div.challenge_add_entry__timeline','3'),
                // m('div.challenge_add_entry__timeline','2'),
                // m('div.challenge_add_entry__save', [
                //     // challenge_state.did_consent && 
                //     m('div.btn.btn--full-width.btn--main', {
                //         onclick: e => add_entry()
                //     }, trans('challenge.send_and_join_challenge')),
                    
                //     // !challenge_state.did_consent && 
                //     // m('div', [
                //     //     m('div.btn.btn--full-width.btn--main', {
                //     //         onclick : function(){
                //     //             set_user_consent(false);
                //     //         }
                //     //     }, trans('common.agree_terms_and_conditions')),
                //     //     // }, trans('common.i_consent_to_terms')),
                //     //     m('br'),
                //     //     m('a.challenge_add_entry__message', {
                //     //         href : '/toc',
                //     //         target : '_blank',
                //     //     }, trans('common.read_terms_and_conditions'))
                //     // ])
                // ]),

            ]),
        ])
    }
}

class OrganizationSelector {
    changeOrganization() {
        // let org = challenge_state.available_organizations.filter(o => o.id_organization == id_organization);
        let org = challenge_state.selected_organizations.list;
        org = org.length > 0 ? org[0] : null; 
        challenge_state.current_organization = org;
        // challenge_state.group.id_organization_group = 0;
        challenge_state.creating_person = false;
        challenge_state.entry_user = { list: [] };
        challenge_state.entry_group = { list: [] };
        get_organizations_groups();
        get_challenge_my_entries();
    }

    view () {
        if (!SPORTNETXPAGE.USER_DATA)
            return;

        return m("div.content-box", [
                m('h2.content-box__title', trans('challenge.join_challenge')),
                // m('div', trans('challenge.select_organization_to_continue')),
                m('.ijf-form', [
                    m('.line', [
                        m('.line-element', [
                            m('label', [
                                trans('challenge.select_organization_to_continue'),
                            ]),
                            
                            !has_permission('challenges.canInsertEntryToAnyone') &&
                            m(SelectTypeahead, {
                                listMode: true,
                                list: challenge_state.available_organizations,
                                selectedItems: challenge_state.selected_organizations, // must be object with 'list' atribute (see function: get_groups())
                                placeholder: trans('challenge.select_organization_text'),
                                noResultsText: trans('common.no_results'),
                                getItemText: o =>  o.title,
                                getItemId: o => o.id_organization,
                                onChange: _ => this.changeOrganization(),
                                type: 'radio'
                            }),

                            has_permission('challenges.canInsertEntryToAnyone') &&
                            m(SelectTypeahead, {
                                listMode: false,
                                getData: getOrganizationsData,
                                selectedItems: challenge_state.selected_organizations, // must be object with 'list' atribute (see function: get_groups())
                                placeholder: trans('challenge.select_organization_text'),
                                noResultsText: trans('common.no_results'),
                                getItemText: getOrganizationTitle,
                                getItemId: i => i.id_organization,
                                onChange: _ => this.changeOrganization(),
                                type: 'radio'
                            })
                            // m('select', {
                            //     value: 0,
                            //     onchange: e => {
                            //         this.changeOrganization(e.target.value*1)
                            //     }
                            // }, [
                            //     m('option', {value: 0}, trans('challenge.select_organization_text')),
                            //     challenge_state.available_organizations.map(_o => {
                            //         return m('option', {
                            //             value: _o.id_organization
                            //         }, _o.title)
                            //     })
                            // ])
                        ])
                    ]),
                ]),
            ]
        );
    }
}

class AllEntries {
    load_more(e) {
        challenge_state.all_entries.page = challenge_state.all_entries.page+1;
        challenge_state.all_entries.load_more = false;
        get_all_entries(false);
    }


    view() {
        let table_class = '.table.table--stripped.table--dark-theme';
        // if(challenge_state.my_entries.editing){
        //     table_class += '.loading'
        // }

        return m(".all-entries-container", [
                m('h2.content-box__title', trans('challenge.entries')),

              
                m('.all_entries', [
                    m('table.table' + table_class, [
                        m('thead',
                            m('tr', [
                                (challenge_state.challenge.entry_type_code == 'individual') &&
                                m('th', trans('challenge.user')),
                                
                                (challenge_state.challenge.entry_type_code == 'group') &&
                                m('th', trans('challenge.group')),

                                has_permission('challenges.canViewByRegion') &&
                                m('th', trans('challenge.organization')),
                                
                                m('th', trans('challenge.entry'))
                            ])),
                        m('tbody', challenge_state.all_entries.list.map(_e => {
                            return m('tr', [
                                (challenge_state.challenge.entry_type_code == 'individual') &&
                                m('td[data-t="User"]', get_person_display_name(_e, 'user_first_name', 'user_last_name', 'user_display_name')),
                                // m('td[data-t="User"]', _e.user_first_name + ' ' + _e.user_last_name),

                                (challenge_state.challenge.entry_type_code == 'group') &&
                                m('td[data-t="Group"]', _e.organization_group),

                                has_permission('challenges.canViewByRegion') &&
                                m('td[data-t="Organization"]', _e.organization),
                                
                                m('td[data-t="Entry"]', Object.values(_e.entry).filter(_x => _x > 0) ? _e.entry_value : 0),                               
                            ])
                        }))
                    ])
                ]),

                (challenge_state.all_entries.load_more && !challenge_state.all_entries.status != 'loading') &&
                m('.btn.btn--small.btn--full-width.load-more', { 
                    onclick: e => this.load_more(e)
                }, trans('common.load_more')),
            ]
        );
    }
}

class AdminEntriesOverview {
    load_more(e) {
        challenge_state.admin_entries.page = challenge_state.admin_entries.page+1;
        challenge_state.admin_entries.load_more = false;
        get_admin_entries(false);
    }


    view() {
        let table_class = '.table.table--stripped.table--dark-theme';
        if(challenge_state.my_entries.editing){
            table_class += '.loading'
        }

        return m("div.content-box", [
                m('.admin-title', [
                    m('h2.content-box__title', [
                        trans('challenge.entries') + ' - ' + trans('common.admin'),
                    ]),
                    m('a.btn', {href: '/api/challenge/entries_csv?id_challenge=' + challenge_state.challenge.id_challenge + '&part=values,city&entry_type_code=' + challenge_state.challenge.entry_type_code + '&order_by=entry_value&limit=-1' }, 'CSV'),
                ]),

                m('.component--filters', [
                    m('.filters-row', [
                        m('.one-filter', [
                            m('.filter-label', trans('challenge.organization')),
                            m(SelectTypeahead, {
                                listMode: false,
                                getData: getOrganizationsData,
                                selectedItems: challenge_state.admin_entries.selected_organizations, // must be object with 'list' atribute (see function: get_groups())
                                placeholder: trans('challenge.select_organization_text'),
                                noResultsText: trans('common.no_results'),
                                getItemText: getOrganizationTitle,
                                getItemId: i => i.id_organization,
                                onChange: _ => get_admin_entries(),
                                type: 'radio'
                            })
                        ]),
                    ])
                ]),

                m('.all_entries', [
                    m('table.table' + table_class, [
                        m('thead',
                            m('tr', [
                                (challenge_state.challenge.entry_type_code == 'individual') &&
                                m('th', trans('challenge.user')),
                                
                                (challenge_state.challenge.entry_type_code == 'group') &&
                                m('th', trans('challenge.group')),
                                
                                m('th', trans('challenge.entry')),
                                
                                m('th', trans('challenge.inserted_by')),
                                
                                m('th', trans('challenge.organization')),


                                m('th', trans('challenge.inserted_at')),
                                m('th', ''),
                            ])),
                        m('tbody', challenge_state.admin_entries.list.map(_e => {
                            return m('tr', [
                                (challenge_state.challenge.entry_type_code == 'individual') &&
                                m('td[data-t="User"]', get_person_display_name(_e, 'user_first_name', 'user_last_name', 'user_display_name')),
                                // m('td[data-t="User"]', _e.user_first_name + ' ' + _e.user_last_name),

                                (challenge_state.challenge.entry_type_code == 'group') &&
                                m('td[data-t="Group"]', _e.organization_group),
                                
                                _e.rejected == 0 && m('td[data-t="Entry"]', Object.values(_e.entry).filter(_x => _x > 0) ? _e.entry_value : 0),
                                _e.rejected == 1 && m('td[data-t="Entry"].rejected', {
                                    title : 'Entry has been rejected'
                                },[
                                    Object.values(_e.entry).filter(_x => _x > 0) ? _e.entry_value : 0,
                                    m.trust(faRejectedEntry)
                                ]),
                                
                                m('td[data-t="Inserted by"]', _e.inserted_by_first_name + ' ' + _e.inserted_by_last_name),
                                m('td[data-t="Organization"]', _e.organization),
                                m('td[data-t="Inserted at"]', new Date(_e.inserted_at).toLocaleDateString("sl-SI")),
                                m('td[data-t="Options"].pointer', m('div.icon', [
                                    (challenge_state.id_user*1 == _e.inserted_by*1 || has_permission('challenges.canInsertEntryToAnyone')) &&
                                    m('svg.svg-inline--fa.fa-trash-alt.fa-w-14', {
                                        'aria-hidden': "true",
                                        focusable: "false",
                                        'data-prefix': "far",
                                        'data-icon': "trash-alt",
                                        role: "img",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        viewBox: "0 0 448 512",
                                        onclick : function(){
                                            delete_entry({
                                                id_entry : _e.id_entry
                                            })
                                        }
                                    }, [
                                        m('title', trans('challenge.delete')),
                                        m('path', {fill: "currentColor", d: "M268 416h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12zM432 80h-82.41l-34-56.7A48 48 0 0 0 274.41 0H173.59a48 48 0 0 0-41.16 23.3L98.41 80H16A16 16 0 0 0 0 96v16a16 16 0 0 0 16 16h16v336a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128h16a16 16 0 0 0 16-16V96a16 16 0 0 0-16-16zM171.84 50.91A6 6 0 0 1 177 48h94a6 6 0 0 1 5.15 2.91L293.61 80H154.39zM368 464H80V128h288zm-212-48h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12z"})
                                    ])
                                ]))
                            ])
                        }))
                    ])
                ]),

                (challenge_state.admin_entries.load_more && !challenge_state.admin_entries.status != 'loading') &&
                m('.btn.btn--small.btn--full-width.load-more', { 
                    onclick: e => this.load_more(e)
                }, trans('common.load_more')),
            ]
        );
    }
}

class GroupCreator {
    oninit(vnode) {
        challenge_state.creating_person = false;
        
        if (challenge_state.creating_group) {
            challenge_state.entry_user = { list: [] };
            reset_new_group_form();
        }
    }

    getUsers(query, data_state) {
        m.request({
            method: "GET",
            url: "/api/users?my_organization=true&order_by=display_name|asc&query="+query,
        }).then(function(data) {
            data_state.results = data.filter(u => u.id_user != challenge_state.id_user);
            data_state.is_loading = false;

            m.redraw();
        });
    }

    onUserSelected(user) {
        if (challenge_state.new_group.users.filter(u => u.id_user == user.id_user).length > 0)
            return;

        challenge_state.new_group.users.push(user);
    }

    removeUser(user) {
        challenge_state.new_group.users = challenge_state.new_group.users.filter(u => u.id_user != user.id_user);
    }

    saveGroup() {
        let problems = [];

        if (!challenge_state.new_group.title || challenge_state.new_group.title.length == 0)
            problems.push(trans('challenge.validation.title_is_required'));

        // if (challenge_state.new_group.users.length == 0)
        // if (challenge_state.entry_user.list.length == 0)
        //     problems.push(trans('challenge.validation.at_least_one_user'));

        if (problems.length > 0) {
            let alert_msg = trans('challenge.validation.cannot_continue')+":\n";
            
            problems.forEach(p => {
                alert_msg += '- ' + p + '\n';

            });

            alert(alert_msg);
            return;
        }

        let users_id = challenge_state.entry_user.list.map(u => u.id_user);

        let data = {
            id_organization: challenge_state.current_organization.id_organization,
            title: challenge_state.new_group.title,
            users: users_id,
            return_model: 1
        };

        if (challenge_state.editing_group) {
            data['id_organization_group'] = challenge_state.new_group.id_organization_group;
        }

        m.request({
            method: "POST",
            url: '/api/organizations_groups',
            responseType: "json",
            body: data
         })
        .then(d => {
            if (challenge_state.creating_group) {
                challenge_state.entry_group.list = [d.feed];
            }

            challenge_state.creating_group = false;
            challenge_state.editing_group = false;
            get_organizations_groups();

            // challenge_state.group.id_organization_group = d.id_organization_group*1; 
            m.redraw();
         })
        .catch(e => {
            alert(trans('challenge.error_loading'))
        })
    }

    view() {
        let creator_title = trans('challenge.create_new_group');

        if (challenge_state.editing_group)
            creator_title = trans('challenge.edit_organization_group')
        
        // return m(".group-creator", [
        return m(".content-box.content-box--half-padding.group-creator", [
                m('h3.content-box__title', creator_title),
                // m('div', trans('challenge.select_organization_to_continue')),
                m('.ijf-form', [
                    m('.line', [
                        m('.line-element', [
                            m('label', [
                                trans('challenge.form.title'),
                                m('span.required-asterisk', '*')
                            ]),
                            m('input', {
                                placeholder: trans('challenge.group_title'),
                                type: 'text',
                                value: challenge_state.new_group.title,
                                onchange: e => { challenge_state.new_group.title = e.target.value }
                            })
                        ]),
                    ]),

                    m(UserSelector, {type: 'checkbox'}),
                ]),

                challenge_state.creating_person &&
                m(PersonCreator),

                m('.ijf-form', [
                    m('.buttons-line', [
                        m('.btn.btn--full-width.btn--main', {
                            onclick: e => this.saveGroup()
                        }, trans('challenge.save_group')),
                        m('.btn', {
                            onclick: e => {
                                challenge_state.creating_group = false;
                                challenge_state.editing_group = false;
                            }
                        }, trans('common.close')),
                    ]),
                ])
            ]
        );
    }
}

class PersonCreator {
    oninit() {
        reset_new_person_form();
    }

    validate() {
        let problems = [];

        if (!challenge_state.new_person.first_name || challenge_state.new_person.first_name.length == 0)
            problems.push(trans('challenge.validation.first_name_is_required'));

        if (!challenge_state.new_person.last_name || challenge_state.new_person.last_name.length == 0)
            problems.push(trans('challenge.validation.last_name_is_required'));

        if (problems.length > 0) {
            let alert_msg = trans('challenge.validation.cannot_continue')+":\n";
            
            problems.forEach(p => {
                alert_msg += '- ' + p + '\n';
            });

            alert(alert_msg);
            return false;
        }

        return true;
    }

    savePerson() {
        if (!this.validate())
            return;

        m.request({
            method: "POST",
            url: '/api/users',
            responseType: "json",
            body: {
                id_organization: challenge_state.current_organization.id_organization,
                first_name: challenge_state.new_person.first_name,
                last_name: challenge_state.new_person.last_name,
                return_model: 1
            }
         })
        .then(d => {
            challenge_state.creating_person = false;

            if (challenge_state.creating_group) {
                challenge_state.entry_user.list.push(d.feed);
            } else {
                challenge_state.entry_user.list = [d.feed];
            }
            m.redraw();
         })
        .catch(e => {
            alert(trans('challenge.error_loading'))
        })
    }

    view() {
        // return m(".person-creator", [
        return m(".content-box.content-box--half-padding.person-creator", [
                m('h3.content-box__title', trans('challenge.create_new_person')),
                m('.ijf-form', [
                    m('.line', [
                        m('.line-element', [
                            m('label', [
                                trans('common.first_name'),
                                m('span.required-asterisk', '*')
                            ]),
                            m('input', {
                                placeholder: trans('common.first_name'),
                                type: 'text',
                                value: challenge_state.new_person.first_name,
                                onchange: e => { challenge_state.new_person.first_name = e.target.value }
                            })
                        ]),

                        m('.line-element', [
                            m('label', [
                                trans('common.last_name'),
                                m('span.required-asterisk', '*')
                            ]),
                            m('input', {
                                placeholder: trans('common.last_name'),
                                type: 'text',
                                value: challenge_state.new_person.last_name,
                                onchange: e => { challenge_state.new_person.last_name = e.target.value }
                            })
                        ]),
                    ]),

                    m('.buttons-line', [
                        m('.btn.btn--full-width.btn--main', {
                            onclick: e => this.savePerson()
                        }, trans('challenge.save_person')),
                        m('.btn', {
                            onclick: e => challenge_state.creating_person = false
                        }, trans('common.close')),
                    ]),
                ]),
            ]
        );
    }
}

class Challenge {
    oninit() {
        get_challenge();
        get_challenge_reports();
        
        if (challenge_state.id_user) {
            get_user_ranking();
        }
    }
    view(){
        if(! challenge_state.loaded){
            return m(Loading)
        }

        let show_organizations_selector = (SPORTNETXPAGE.USER && !challenge_state.current_organization);

        let has_roles = challenge_state.user_has_roles;

        if (challenge_state.challenge.entry_type_code == 'group' && !has_permission('challenges.canInsertGroupEntries')) {
            has_roles = false;
        }


        return [
            m("div.page-header",
                [
                    m("div.page-header__background",
                        challenge_state.bg_img && m('div.page-header__background__image', {
                            style : 'background-image: url(\'' + challenge_state.bg_img + '\')'
                        })
                    ),
                    m("div.page-header__content.page-header__content--with-back_button.page-header__content--left-right", [
                        m('.page-header__content__left', [
                            m('.page-header__back-button', {
                                // href : '/challenges'
                                style: "cursor: pointer",
                                onclick: e => goBack()
                            },[
                                m.trust(faChevronLeft),
                                trans('challenge.back_to_beginning')
                            ]),
                            m("div.page-header__article-title",
                                {
                                    'data-title' : challenge_state.challenge.title
                                },
                                challenge_state.challenge.title
                            ),

                            m("h2.duration-title",
                                // {
                                //     'data-title' : challenge_state.challenge.title
                                // },
                                (challenge_state.challenge.starts_at && challenge_state.challenge.ends_at) &&
                                trans('challenge.challenge_duration') + ': ' + challenge_state.challenge.starts_at + ' - ' + challenge_state.challenge.ends_at,
                                
                                (challenge_state.challenge.starts_at && !challenge_state.challenge.ends_at && challenge_state.challenge_not_started) &&
                                trans('challenge.challenge_starts_at') + ': ' + challenge_state.challenge.starts_at
                            ),
                            
                            m('.page-header__share', [
                                (challenge_state.challenge.public == 1 || challenge_state.challenge.unlisted == 1) &&
                                [
                                    m('.page-header__share--title', trans('common.share').toUpperCase() + ':'),
                                    m('.article-share', [
                                        m('.article-share__icons', [
                                            m('a.facebook--white', { 
                                                href: "https://www.facebook.com/sharer/sharer.php?u=" + SPORTNETXPAGE.BASEURL + "/challenge/view/" + challenge_state.challenge.slug,
                                                target: "_blank"
                                            }),
                                            m('a.twitter--white', { 
                                                href: "https://twitter.com/home?status=" + SPORTNETXPAGE.BASEURL + "/challenge/view/" + challenge_state.challenge.slug,
                                                target: "_blank"
                                            }),
                                            m('a.email--white', { 
                                                href: "mailto:friend@example.com?subject=Športni izziv&body=Look at this: " + SPORTNETXPAGE.BASEURL + "/challenge/view/" + challenge_state.challenge.slug,
                                            }),
                                            m('a.telegram--white', { 
                                                href: "https://telegram.me/share/url?url=" + SPORTNETXPAGE.BASEURL + "/challenge/view/" + challenge_state.challenge.slug +"&text=Look at this:",
                                                target: "_blank"
                                            }),
                                            // m('a.share--white', { 
                                            //     href: "#",
                                            //     title: "Kopiraj url",
                                            //     onclick: e => {
                                            //         e.preventDefault();

                                            //     }
                                            // })
                                        ])
                                    ])
                                ],

                                (challenge_state.challenge.public == 0 && challenge_state.challenge.unlisted == 0) &&
                                m('.page-header__share--title', trans('common.cannot_share_private_challenge')),
                            ])
                        ]),

                        m('.page-header__content__right', [
                            (challenge_state.challenge.id_user == challenge_state.id_user) &&
                            m('a.btn', {
                                href: '/challenge/edit/' + challenge_state.challenge.id_challenge
                            }, trans('challenge.edit_challenge')),

                            challenge_state.can_request_public_challenge &&
                            [
                                !challenge_state.sending_public_challenge_request &&
                                m('.btn', {
                                    onclick: e => request_public_challenge()
                                }, trans('challenge.request_public_challenge')),
                                
                                challenge_state.sending_public_challenge_request &&
                                m('h3', trans('challenge.sending_public_request') + '...')
                            ],

                            (!challenge_state.can_request_public_challenge && challenge_state.public_challenge_requested) &&
                            m('h3', trans('challenge.public_challenge_requested'))
                        ]),

                        // m('.page-header__content__right', [
                        // ])
                    ])
                ]
            ),


            m("div.main-content.main-content--with-page-header.page--upload",
                [
                    m("div.content-box", [
                        challenge_state.loaded && 
                        [
                            // m('.challenge-info', m(ChallengeStartsEndsInfo)), 
                            m('.challenge-info', m(ChallengeExercises)), 
                            m('.challenge-info', m(ChallengeAdditionalInfo)),

                            (challenge_state.challenge.is_on_program == 0 && challenge_state.all_entries.list.length > 0 && !has_permission('challenges.canInsertEntryToAnyone')) &&
                            m(AllEntries)
                        ]
                    ]),
                    
                    (!SPORTNETXPAGE.USER && challenge_state.challenge_is_active) &&
                    m("div.content-box", 
                        m('h2.content-box__title', trans('challenge.join_challenge')),
                        m('a.btn', {
                            // href : 'https://account.ijf.org/Account/Login?backTo=http://izziv.sportmladih.net/challenge/view/' + challenge_state.challenge.id_challenge
                            href : SPORTNETXPAGE.SPORTNETXLINK + '?backTo=' + SPORTNETXPAGE.BASEURL + '/sso/login'
                        }, trans('challenge.login_message'))
                    ),

                    (has_roles && challenge_state.challenge_is_active) &&
                    [
                        (show_organizations_selector) &&
                        m(OrganizationSelector),

                        (show_organizations_selector && has_permission('challenges.canInsertEntryToAnyone')) &&
                        m(AdminEntriesOverview),

                        (SPORTNETXPAGE.USER && !show_organizations_selector) &&
                        m("div.content-box", 
                            [
                                m('h2.content-box__title', [
                                    trans('challenge.join_challenge'),
                                ]),
                                challenge_state.loaded && m(AddEntryContainer)
                            ],    
                            [
                                m(ChallengeUserLeaderboards),
                                
                                m('div.content-box__title.content-box__title__with-subtitle', [
                                    m('h2', trans('challenge.my_entries')),
                                ]),
                                challenge_state.loaded && m(ChallengeUserEntries),
                            ]
                        ),
                    ],

                    !challenge_state.challenge_is_active &&
                    [

                        challenge_state.challenge_has_ended &&
                        m("div.content-box", 
                            m('h2.content-box__title', trans('challenge.challenge_has_ended_title') + '!'),
                            m('div', trans('challenge.challenge_has_ended_text'))
                        ),

                        challenge_state.challenge_not_started &&
                        m("div.content-box", 
                            m('h2.content-box__title', trans('challenge.challenge_not_started_title')),
                            m('div', trans('challenge.challenge_not_started_text'))
                        ),

                        has_permission('challenges.canInsertEntryToAnyone') &&
                        m(AdminEntriesOverview),
                    ]
                ]
            ),
        ]
    }
}

class ChallengeUserLeaderboards {
    view(){
        if(! challenge_state.leaderboards.list.length ){
            return;
        }

        // content-box
        return m('div.challenge_leaderboards', [
            m('div.content-box__title-with-button', [
                m('div.content-box__title.content-box__title__with-subtitle', [
                    m('h2', trans('challenge.participate_in_leaderboards')),
                    m('small', trans('challenge.leaderboard_notice'))
                ]),

                // m('h2.content-box__title', trans('challenge.participate_in_leaderboards')),
                m('a.btn', {
                    href : '/rankings/challenges/' + challenge_state.id_challenge
                }, trans('common.view_rankings'))
            ]),
            m('div.challenge_part_lb' + (challenge_state.user_leaderboards.editing ? '.challenge_part_lb--loading' : ''), [
                challenge_state.leaderboards.list.map(_lb => {
                    let is_participating = challenge_state
                        .user_leaderboards
                        .list
                        .filter(_ulb => {
                            return _ulb.code == _lb.code
                        })
                        .length > 0

                    return m('div.challenge_part_lb__box' + (is_participating ? '.challenge_part_lb__box--active' : ''), {
                            onclick : function(){
                                if(is_participating){
                                    update_user_leaderboard_participation({
                                        remove : [_lb.id_leaderboard]
                                    })
                                }else{
                                    update_user_leaderboard_participation({
                                        add : [_lb.id_leaderboard]
                                    })
                                }
                            }
                        },
                        [
                        m('div', trans('rankings.leaderboards.' + _lb.code))
                    ])
                })
            ])
        ])
    }
}

class Rankings {
    view(){
        let main_rankings = ['over_all', 'm', 'w'];

        return m('div.content-box.rankings', [
            m('.ranking-header', [
                m('.ranking-header__title', trans('challenge.best_of_challenge')),
                m('.ranking-header__btn', [
                    m('a.btn', {href: '/rankings/challenges/'+challenge_state.challenge.id_challenge}, trans('rankings.view_all'))
                ])
            ]),
            m('.ranking-grid', [
                main_rankings.map(leaderboard_code => {
                    let leaderboard = challenge_state.challenge.rankings[leaderboard_code];

                    return m('.panel.ranking', [
                        m('.panel__header', [
                            m('.panel__header__title-link', 
                                m('a', {href: '/rankings/challenges/'+challenge_state.challenge.id_challenge+'/'+leaderboard_code}, trans('rankings.leaderboards.' + leaderboard_code))
                            )
                        ]),

                        (leaderboard.length == 0) &&
                        m('div', trans('rankings.no_rankings_for_leaderboard')),
                        
                        m('table..table.table--stripped.table--dark-theme', [
                            m('tbody', [

                                (leaderboard.length > 0) &&
                                leaderboard.map(ranking => {
                                    return m('tr'+(challenge_state.id_user && challenge_state.id_user == ranking.id_user ? '.user-row' : ''), [
                                        m('td'+(ranking.place == 1 ? '.mark--yellow' : (ranking.place == 2 ? '.mark--grey' : (ranking.place == 3 ? '.mark--orange' : '.mark--empty')))),
                                        m('td.rank', ranking.place),
                                        m('td.image', 
                                            m('.image__container', [
                                                ranking.profile_picture_url &&
                                                m('img', {src: "https://res.cloudinary.com/duu3v9gfg/image/fetch/t_flag_w_40/"+ranking.profile_picture_url, alt: "UsersEdit image of " + ranking.display_name}),

                                                !ranking.profile_picture_url &&
                                                m('img', {src: "https://res.cloudinary.com/duu3v9gfg/image/fetch/t_flag_w_40/https://78884ca60822a34fb0e6-082b8fd5551e97bc65e327988b444396.ssl.cf3.rackcdn.com/user_profile/default.jpg"})
                                            ])
                                        ),
                                        m('td.name', [
                                            m('a', {href: '/entries/view/'+ranking.id_entry}, ranking.display_name)
                                        ]),
                                        m('td.points.nowrap', ranking.entry_value),
                                        m('td.watch', [
                                            (ranking.id_video > 0) &&
                                            m('a.fa--main-color', {href: '/entries/view/'+ranking.id_entry}, 
                                                m('svg.svg-inline--fa.fa-play.fa-w-14',
                                                    {
                                                        'aria-hidden': "true",
                                                        focusable: "false",
                                                        'data-prefix': "fas",
                                                        'data-icon': "play",
                                                        role: "img",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        viewBox: "0 0 448 512"
                                                    },
                                                    m('path', {fill: "currentColor", d: "M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"})
                                                )
                                            ),

                                            (ranking.id_video <= 0) &&
                                            m('a', {href: '/entries/view/'+ranking.id_entry}, 
                                                m('svg.svg-inline--fa.fa-play.fa-w-14',
                                                    {
                                                        'aria-hidden': "true",
                                                        focusable: "false",
                                                        'data-prefix': "fas",
                                                        'data-icon': "file-alt",
                                                        role: "img",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        viewBox: "0 0 384 512"
                                                    },
                                                    m('path', {fill: "currentColor", d: "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 236c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-64c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-72v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm96-114.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"})
                                                )
                                            )
                                        ])
                                    ])
                                }),

                                (challenge_state.id_user && challenge_state.user_rankings) &&
                                challenge_state.user_rankings.map(ranking => {
                                    if (ranking.leaderboard_code != leaderboard_code || ranking.place < 4)
                                        return;

                                    return m('tr.user-row', [
                                        m('td.mark--orange'),
                                        m('td.rank', ranking.place),
                                        m('td.image', 
                                            m('.image__container', [
                                                ranking.profile_picture_url &&
                                                m('img', {src: "https://res.cloudinary.com/duu3v9gfg/image/fetch/t_flag_w_40/"+ranking.profile_picture_url, alt: "UsersEdit image of " + ranking.display_name}),

                                                !ranking.profile_picture_url &&
                                                m('img', {src: "https://res.cloudinary.com/duu3v9gfg/image/fetch/t_flag_w_40/https://78884ca60822a34fb0e6-082b8fd5551e97bc65e327988b444396.ssl.cf3.rackcdn.com/user_profile/default.jpg"})
                                            ])
                                        ),
                                        m('td.name', [
                                            m('a', {href: '/entries/view/'+ranking.id_entry}, ranking.display_name)
                                        ]),
                                        m('td.points.nowrap', ranking.entry_value),
                                        m('td.watch', [
                                            (ranking.id_video > 0) &&
                                            m('a.fa--main-color', {href: '/entries/view/'+ranking.id_entry}, 
                                                m('svg.svg-inline--fa.fa-play.fa-w-14',
                                                    {
                                                        'aria-hidden': "true",
                                                        focusable: "false",
                                                        'data-prefix': "fas",
                                                        'data-icon': "play",
                                                        role: "img",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        viewBox: "0 0 448 512"
                                                    },
                                                    m('path', {fill: "currentColor", d: "M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"})
                                                )
                                            ),

                                            (ranking.id_video <= 0) &&
                                            m('a', {href: '/entries/view/'+ranking.id_entry}, 
                                                m('svg.svg-inline--fa.fa-play.fa-w-14',
                                                    {
                                                        'aria-hidden': "true",
                                                        focusable: "false",
                                                        'data-prefix': "fas",
                                                        'data-icon': "file-alt",
                                                        role: "img",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        viewBox: "0 0 384 512"
                                                    },
                                                    m('path', {fill: "currentColor", d: "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 236c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-64c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-72v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm96-114.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"})
                                                )
                                            )
                                        ])
                                    ]);
                                })
                            ])
                        ])
                    ]);
                })
            ])
        ])
    }
}

class Awards {
    oninit() {
        SPORTNETXPAGE.USER && get_user_awards();
    }

    getIcon(achievement_code) {
        switch (achievement_code) {
            case 'judo_cup':
                return faAwardChallengeJudoFit;
            case 'bronze':
                return faAwardChallengeBronzeFit;
            case 'silver':
                return faAwardChallengeSliverFit;
            case 'gold':
                return faAwardChallengeGoldFit;
        }

        return faAwardChallengeJudoFit;
    }

    view(){
        if(!challenge_state.challenge.achievements || challenge_state.challenge.achievements.length == 0){
            return;
        }

        let my_achievemnts = 0;

        if (challenge_state.user_achievements.status == 'loaded') {
            my_achievemnts = challenge_state.user_achievements.list.filter(a => a.code == 'judo_cup' || a.code == 'bronze' || a.code == 'silver' || a.code == 'gold').length;
        }

        return m('div.content-box', [
            SPORTNETXPAGE.USER && m('h2.content-box__title', trans('challenge.your_awards')),
            !SPORTNETXPAGE.USER && m('h2.content-box__title', trans('challenge.participate_to_win')),
            m('.challenge_awards'), [
                challenge_state.challenge.achievements.map(achievement => {
                    return m('.award' + (my_achievemnts >= achievement.num_items ? '.award--achieved' : ''), [
                        m('.award__image', m.trust(this.getIcon(achievement.code))),
                        m('.award__goal', achievement.goal),
                    ])
                })
            ]
        ])
    }
}

function get_challenge_reports() {
    m.request('/api/challenge/reports' + '?id_challenge='+ encodeURIComponent(challenge_state.id_challenge))
     .then(d => {
         // console.log(d);
         challenge_state.reports = d;
         challenge_state.reports_loaded = true;
      })
     .catch(e => {
         alert(trans('challenge.error_loading'))
      })
}

function report_challenge() {
    m.request({
         method: "POST",
         url: '/api/challenge/report_challenge',
         responseType: "json",
         body: {
             id_challenge: challenge_state.id_challenge
         }
      })
     .then(d => {
         get_challenge_reports();
      })
     .catch(e => {
         alert(trans('challenge.error_loading'))
      })
}

function update_user_leaderboard_participation(what){
    let data = Object.assign({
        id_challenge : challenge_state.challenge.id_challenge,
    }, what)

    challenge_state.user_leaderboards.editing = true;

    m.request({
        url : '/api/challenge_user_leaderboards',
        method : 'POST',
        responseType: "json",
        body : data
    }).then(d => {
        challenge_state.user_leaderboards.editing = false;
        get_user_leaderboards()
    }).catch(e => {
        challenge_state.user_leaderboards.editing = false;
        alert('Error editing participation')
    })
}

function update_entry(data){
    challenge_state.my_entries.editing = true;
    m.request({
        url : '/api/challenge/edit_entry',
        method : 'POST',
        responseType: "json",
        body : data
    }).then(d => {
        challenge_state.my_entries.editing = false;
        get_challenge_my_entries();
        get_all_entries();
    }).catch(e => {
        challenge_state.my_entries.editing = false;
        alert(trans('challenge.error_editing_entry'))
    })
}

function delete_entry(data){
    let confirm_delete = confirm(trans('challenge.confirm_remove_entry'));

    if (!confirm_delete)
        return;

    challenge_state.my_entries.editing = true;
    m.request({
        url : '/api/challenge/remove_entry',
        method : 'POST',
        responseType: "json",
        body : data
    }).then(d => {
        challenge_state.my_entries.editing = false;
        get_challenge_my_entries();
        get_all_entries();

        if (has_permission('challenges.canInsertEntryToAnyone'))
            get_admin_entries();

    }).catch(e => {
        alert(trans('challenge.error_delete_entry'))
        challenge_state.my_entries.editing = false;
    })
}

function get_user_consent(){
    if(!SPORTNETXPAGE.USER || !SPORTNETXPAGE.USER.id_user){
        return;
    }

    m.request('/api/user/consent').then(d => {
        // console.log(d)
        challenge_state.did_consent = d.consent_at != null;
    }).catch(e => {
        console.log(e)
        alert('Please refresh page')
    })
}

function set_user_consent(add_entry_after_consent){
    m.request({
        method : 'post',
        url: '/api/user/consent',
        body: {
            only_kids: 0
        }
    }).then(d => {
        // console.log(d)
        get_user_consent()
        // console.log(add_entry_after_consent)
        if(add_entry_after_consent){
            add_entry()
        }else{
            alert(trans('challenge.consent_add_entry'))
        }
    }).catch(e => {
        console.log(e)
        alert('Please refresh page')
    })
}

function add_entry(){
    if(challenge_state.new_entry.status == 'adding'){
        return;
    }

    if (challenge_state.entry_inserted || challenge_state.entry_error) {
        return; 
    }

    challenge_state.new_entry.status = 'adding';

    let id_user = null;
    if (challenge_state.challenge.entry_type_code == 'individual') {
        if (challenge_state.target_user_type == 'self') {
            id_user = challenge_state.id_user;
        }
        if (challenge_state.target_user_type == 'other') {
            if (challenge_state.entry_user.list.length == 0) {
                // alert('Please enter for who you want to enter results');
                // challenge_state.new_entry.status = 'none';
                // return;
                id_user = null;
            } else {
                id_user = challenge_state.entry_user.list[0].id_user;
            }
        }
    }

    let id_group = null;
    if (challenge_state.challenge.entry_type_code == 'group') {
        if (challenge_state.entry_group.list.length == 0) {
            // alert('Please select group');
            // challenge_state.new_entry.status = 'none';
            // return;
            id_group = null;
        } else {
            id_group = challenge_state.entry_group.list[0].id_organization_group;
        }

        // reset_new_group_form();
    }

    // reset_new_person_form();

    let request_body = Object.assign({}, challenge_state.new_entry, {
        id_challenge : challenge_state.challenge.id_challenge,
        id_organization : challenge_state.current_organization ? challenge_state.current_organization.id_organization : null, 
        id_user : id_user,
        id_group : id_group
    });

    challenge_state.new_entry.entry = {};

    challenge_state.entry_error_msg = '';

    m.request({
        url : '/api/challenge/add_entry',
        method : 'POST',
        responseType: "json",
        body : request_body
    }).then(d => {
        // console.log(d)
        challenge_state.new_entry.status = 'none';
        get_challenge_my_entries();
        get_all_entries();
        // get_user_leaderboards();
        // get_user_awards();

        reset_entry_form();

        if (challenge_state.must_select_target_user_type) {
            challenge_state.target_user_type = false;            
        }

        challenge_state.entry_inserted = true;
        
        m.redraw();

        setTimeout(e => {
            challenge_state.entry_inserted = false;
            m.redraw();
        }, 2500);

    }).catch(e => {
        challenge_state.new_entry.status = 'none';
        // let err = trans('challenge.error_add_entry')
        // if(e && e.response && e.response.error && e.response.error.description){
        //     err += "\n" + e.response.error.description
        // }
        // alert(err);

        if(e && e.response && e.response.error && e.response.error.description){
            challenge_state.entry_error_msg = e.response.error.description;
        }

        challenge_state.entry_error = true;
        
        m.redraw();

        setTimeout(e => {
            challenge_state.entry_error = false;
            m.redraw();
        }, 3500);
    })
}

function get_challenge() {
    m.request('/api/challenge' +
        '?id_challenge='+ encodeURIComponent(challenge_state.id_challenge) +
        '&part=info,exercises,roles,content,organizations_recursive,sports,group_items,is_on_program&exercises_with_content=true')
        // '&part=info,exercises,achievements,content&rankings=over_all,m,w,kids_14&exercises_with_content=true')
        .then(d => {
            // console.log(d);
            challenge_state.challenge = d;
            challenge_state.loaded = true;
            
            if (challenge_state.challenge.exercises.length) {
                challenge_state.bg_img = challenge_state.challenge.exercises[0].url_poster;
            }


            let now_date = new Date();
                
            if (challenge_state.challenge.starts_at) {
                let starts_at_date = new Date(challenge_state.challenge.starts_at);
                
                if (now_date < starts_at_date) {
                    challenge_state.challenge_not_started = true;
                }

                challenge_state.challenge.starts_at = new Date( challenge_state.challenge.starts_at).toLocaleDateString("sl-SI");
            }

            if (challenge_state.challenge.ends_at) {
                let ends_at_date = new Date(challenge_state.challenge.ends_at);

                if (now_date > ends_at_date) {
                    challenge_state.challenge_has_ended = true;
                }

                challenge_state.challenge.ends_at = new Date( challenge_state.challenge.ends_at).toLocaleDateString("sl-SI");
            }

            if (challenge_state.challenge_not_started || challenge_state.challenge_has_ended) {
                challenge_state.challenge_is_active = false;
            }

            if (SPORTNETXPAGE.USER) {
                // get_leaderboards();
                // get_user_leaderboards();
                get_user_consent();
                challenge_state.user_has_roles = user_has_roles();

                // let challenge_organizations_ids = challenge_state.challenge.organizations.map(org => org.id_organization*1);
                // challenge_state.available_organizations = Object.values(SPORTNETXPAGE.USER_DATA.organizations);

                // // if challenge has no organizations, you can choose any one of your organizations
                // if (challenge_organizations_ids.length > 0) {
                //     challenge_state.available_organizations = challenge_state.available_organizations.filter(org => challenge_organizations_ids.includes(org.id_organization*1));
                // }

                if (has_permission('challenges.canInsertEntryToAnyone')) {
                    challenge_state.available_organizations = challenge_state.challenge.organizations;
                } else if (has_permission('challenges.canViewBySport') || has_permission('challenges.canViewByRegion')) {
                    challenge_state.available_organizations = Object.values(SPORTNETXPAGE.USER_DATA.organizations);
                } else {
                    let challenge_organizations_ids = challenge_state.challenge.organizations.map(org => org.id_organization*1);
                    challenge_state.available_organizations = Object.values(SPORTNETXPAGE.USER_DATA.organizations);

                    // if challenge has no organizations, you can choose any one of your organizations
                    if (challenge_organizations_ids.length > 0) {
                        challenge_state.available_organizations = challenge_state.available_organizations.filter(org => challenge_organizations_ids.includes(org.id_organization*1));
                    }
                }
                
                if (challenge_state.available_organizations.length == 1 && !has_permission('challenges.canInsertEntryToAnyone')) {
                    challenge_state.current_organization = challenge_state.available_organizations[0];
                }

                if (challenge_state.challenge.private_validated == 1 && 
                    challenge_state.challenge.validated         == 0 && 
                    challenge_state.challenge.requested_public  == 0 && 
                    challenge_state.challenge.rejected          == 0 &&
                    challenge_state.challenge.id_user           == challenge_state.id_user) {


                    challenge_state.can_request_public_challenge = true;
                }

                if (challenge_state.challenge.validated         == 0 && 
                    challenge_state.challenge.requested_public  == 1 && 
                    challenge_state.challenge.id_user           == challenge_state.id_user) {


                    challenge_state.public_challenge_requested = true;
                }
            }

            get_challenge_my_entries();
            get_all_entries();

            if (has_permission('challenges.canInsertEntryToAnyone')) {
                get_admin_entries();
            }
        })
        .catch(e => {
            alert(trans('challenge.error_loading'))
        })
}

function get_organizations_groups() {
    if (!challenge_state.current_organization)
        return;

    m.request('/api/organizations_groups?id_organization=' + challenge_state.current_organization.id_organization)
     .then(d => {
        challenge_state.groups.list = d;
        m.redraw();
     })
     .catch(e => {
        console.log(e);
        alert(trans('challenge.error_loading'))
     })
}

function get_organizations_group(id_organization_group) {
    m.request('/api/organizations_groups?part=users&id_organization_group=' + id_organization_group)
     .then(d => {
        // console.log(d);

        // challenge_state.new_group = {
        //     list: [d]
        // }

        challenge_state.new_group = d;

        let users = d.users.map(u => {
            u['id_user'] = u.id_user*1;
            return u;
        })

        challenge_state.entry_user['list'] = d.users;

        m.redraw();
     })
     .catch(e => {
        console.log(e);
        alert(trans('challenge.error_loading'))
     })
}

function get_user_ranking(){
    if (!challenge_state.id_user)
        return;

    m.request('/api/challenge/user_rankings' +
        '?id_challenge='+ encodeURIComponent(challenge_state.id_challenge) +
        '&id_user=' + encodeURIComponent(challenge_state.id_user))
        .then(d => {
            challenge_state.user_rankings = d;
        })
        .catch(e => {
            alert(trans('challenge.error_loading'))
        })
}

function get_challenge_my_entries(override=true){
    if (! SPORTNETXPAGE.USER){
        return;
    }

    if (override) {
        challenge_state.my_entries.page = 1;
    }

    challenge_state.my_entries.load_more = false;

    let request_url = '/api/challenge/entries' +
                      '?id_challenge='+ challenge_state.challenge.id_challenge +
                      '&part=values'+
                      // '&inserted_by=' + challenge_state.id_user + 
                      '&page=' + challenge_state.my_entries.page +
                      '&limit=' + challenge_state.my_entries.limit +
                      '&mine=1' +
                      '&order_by=entry_value';
                      // '&order_by=entry_of|asc';

    if (challenge_state.current_organization) {
        request_url += '&id_organization=' + challenge_state.current_organization.id_organization +
                       '&entry_type_code=' + challenge_state.challenge.entry_type_code;
    }         

    m.request(request_url)
        .then(d => {
            challenge_state.my_entries.status = 'loaded';
            // challenge_state.my_entries.list = d;

            if (d.length > challenge_state.my_entries.limit) {
                challenge_state.my_entries.load_more = true;
                d = d.slice(0, challenge_state.my_entries.limit);
            }

            if (override) {
                challenge_state.my_entries.list = d;                
            } else {
                challenge_state.my_entries.list = challenge_state.my_entries.list.concat(d);
            }
        })
        .catch(e => {
            challenge_state.my_entries.status = 'error';
            alert(trans('challenge.error_loading_entries'))
        })
}

function get_admin_entries(override=true) {
    if (!has_permission('challenges.canInsertEntryToAnyone')){
        return;
    }

    if (override) {
        challenge_state.admin_entries.page = 1;
    }

    challenge_state.admin_entries.load_more = false;

    let request_url = '/api/challenge/entries' +
                      '?id_challenge='+ challenge_state.challenge.id_challenge +
                      '&part=values'+
                      '&entry_type_code=' + challenge_state.challenge.entry_type_code +
                      '&page=' + challenge_state.admin_entries.page +
                      '&limit=' + challenge_state.admin_entries.limit +
                      '&order_by=entry_value';
                      // '&order_by=entry_of|asc';

    if (challenge_state.admin_entries.selected_organizations.list.length > 0) {
        request_url += '&id_organization=' + challenge_state.admin_entries.selected_organizations.list[0].id_organization
    }    

    // if (challenge_state.current_organization) {
    //     request_url += '&id_organization=' + challenge_state.current_organization.id_organization +
    //                    '&entry_type_code=' + challenge_state.challenge.entry_type_code;
    // }    

    challenge_state.admin_entries.status = 'loading';     

    m.request(request_url)
        .then(d => {
            challenge_state.admin_entries.status = 'loaded';

            if (d.length > challenge_state.admin_entries.limit) {
                challenge_state.admin_entries.load_more = true;
                d = d.slice(0, challenge_state.admin_entries.limit);
            }

            if (override) {
                challenge_state.admin_entries.list = d;                
            } else {
                challenge_state.admin_entries.list = challenge_state.admin_entries.list.concat(d);
            }
            
            m.redraw();
        })
        .catch(e => {
            challenge_state.admin_entries.status = 'error';
            alert(trans('challenge.error_loading_entries'))
        })
}

function get_all_entries(override=true) {
    if (override) {
        challenge_state.all_entries.page = 1;
    }

    challenge_state.all_entries.load_more = false;

    let request_url = '/api/challenge/entries' +
                      '?id_challenge='+ challenge_state.challenge.id_challenge +
                      '&part=values'+
                      '&entry_type_code=' + challenge_state.challenge.entry_type_code +
                      '&page=' + challenge_state.all_entries.page +
                      '&limit=' + challenge_state.all_entries.limit +
                      '&visibility=public' +
                      '&order_by=entry_value';
                      // '&order_by=entry_of|asc';

    // if (challenge_state.all_entries.selected_organizations.list.length > 0) {
    //     request_url += '&id_organization=' + challenge_state.all_entries.selected_organizations.list[0].id_organization
    // }    


    challenge_state.all_entries.status = 'loading';     

    m.request(request_url)
        .then(d => {
            challenge_state.all_entries.status = 'loaded';

            if (d.length > challenge_state.all_entries.limit) {
                challenge_state.all_entries.load_more = true;
                d = d.slice(0, challenge_state.all_entries.limit);
            }

            if (override) {
                challenge_state.all_entries.list = d;                
            } else {
                challenge_state.all_entries.list = challenge_state.all_entries.list.concat(d);
            }
            
            m.redraw();
        })
        .catch(e => {
            challenge_state.all_entries.status = 'error';
            alert(trans('challenge.error_loading_entries'))
        })
}


function get_leaderboards(){
    m.request('/api/leaderboards?')
        .then(d => {
            challenge_state.leaderboards.status = 'loaded';
            challenge_state.leaderboards.list = d.feed;
        })
        .catch(e => {
            challenge_state.my_entries.status = 'error';
            alert(trans('challenge.error_loading_leaderboards'))
        })
}

function get_user_leaderboards(){
    m.request('/api/challenge_user_leaderboards' +
        '?id_challenge='+ challenge_state.challenge.id_challenge)
        .then(d => {
            challenge_state.user_leaderboards.status = 'loaded';
            challenge_state.user_leaderboards.list = d.feed;
        })
        .catch(e => {
            challenge_state.my_entries.status = 'error';
            alert(trans('challenge.error_loading_leaderboards_participation'))
        })
}

function get_one_time_inputs(){
    m.request('/api/one_time_inputs')
        .then(ac => {
            challenge_state.age_categories = ac.feed;
            challenge_state.user.has_age_category = ac.has_age_category*1;
            challenge_state.user.has_weight = ac.has_weight_measurement*1;
            challenge_state.user.has_gender = ac.has_gender*1;
        });
}

function get_user_awards(){
    m.request('/api/user_achievements?id_challenge='+ challenge_state.challenge.id_challenge)
        .then(d => {
            challenge_state.user_achievements.status = 'loaded';
            challenge_state.user_achievements.list = d;
        })
        .catch(e => {
            challenge_state.my_entries.status = 'error';
            alert(trans('challenge.error_loading_awards'))
        })
}

function uploadVideo() {

    var file = challenge_state.video_status.file;

    let extension = file.name.split('.').pop().toLowerCase();

    // alert('Extension ' + extension); // DBG

    if (extension != 'mp4' && extension != 'flv' && extension != 'mov' && extension != 'mpg' && extension != 'mpeg') {
        alert("Wrong file format. Supported types: mp4, flv, mov, mpg");
        return;
    }

    let data = {
        type: 'video',
        entity: 'challenges',
        id_entity: challenge_state.challenge.id_challenge,
        file: {
            name: file.name,
            size: file.size,
            type: file.type
        },
        validated: 1
    };

    m.request({
        method: "POST",
        url: "/api/media",
        body: data
    }).then(function(data) {
        // alert('data status ' + data.status); // DBG
        if (data.status == 200) {
            challenge_state.new_entry.id_video = data.id_uploaded;
            challenge_state.video_status.name = file.name;

            upload_video(file, data.id_uploaded, data.upload_url);
        } else {
            alert("ERROR!");
        }
    });

}


function upload_video(file, id_video, upload_url){
    // alert('uploading video ' + id_video + ' ' + upload_url); // DBG
    challenge_state.video_status.upload_progress = 0;

    challenge_state.video_status.status = 'uploading';

    var xmlHttpRequest = new XMLHttpRequest();
    xmlHttpRequest.open("PUT", upload_url, true);

    xmlHttpRequest.setRequestHeader("Content-Type", file.type);

    xmlHttpRequest.upload.addEventListener("progress", function(e) {
        let progress = (e.loaded / e.total) * 100;
        progress = Math.floor(progress);
        console.log(progress, e)
        if(progress >= 100){
            progress = 100;

            setTimeout(function(){
                // alert('upload finished ' + id_video); // DBG
                m.request({
                    method: "GET",
                    url: '/api/media/upload_video_finished/' + id_video,
                }).then(function(data) {

                    if(data.status == 200){

                        console.log('UPLOADED!');
                        challenge_state.video_status.status = 'finished';

                        alert('Upload finished. You can now add entry with video')

                    }else{

                        console.log('upload error!');
                        challenge_state.video_status.status = 'finished';

                        alert('Error finishing upload. Please try again or contact admin. Id video: ' + id_video)
                        challenge_state.new_entry.id_video = 0;

                    }

                }).catch(function(){
                    alert('Error finishing upload. Please try again or contact admin.')
                });
            }, 5000)
        }

        challenge_state.video_status.upload_progress = progress;

        m.redraw()
    });
    xmlHttpRequest.upload.addEventListener("loadx", function(e){
        setTimeout(function(){
            m.request({
                method: "GET",
                url: '/api/media/upload_video_finished/' + id_video,
            }).then(function(data) {
                console.log('UPLOADED!');
            });
        }, 2000)
        challenge_state.video_status.status = 'finished';
        m.redraw();
    })
    xmlHttpRequest.upload.addEventListener("errorx", function(e){
        alert('Looks like there was problem uploading. Please try again or contact us');
        challenge_state.video_status.status = 'error';
        m.redraw();
    })
    xmlHttpRequest.upload.addEventListener("abortx", function(e){
        alert('Looks like there was problem uploading. Please try again or contact us');
        challenge_state.video_status.status = 'error';
        m.redraw();
    })

    xmlHttpRequest.send(file);
}

function getOrganizationsData(query, data_state, onDataLoaded, ctx) {
    let challenge_organizations_ids = challenge_state.challenge.organizations.map(org => org.id_organization*1);
    let challenge_organizations_ids_str = '';

    let additional_query = '';

    if (challenge_organizations_ids.length > 0) {
        challenge_organizations_ids_str = challenge_organizations_ids.join(',')

        additional_query += 'organization_ids=' + challenge_organizations_ids_str + '&';
    }

    m.request({
        method: "GET",
        url: "/api/organizations?order_by=long_title|asc&" + additional_query + "query="+query,
    }).then(function(data) {
        data_state.results = data;
        data_state.is_loading = false;

        m.redraw();
    });
}

function request_public_challenge() {
    let confirm_message = trans('challenge.confirm_request_public_title') + '\n\n';
    confirm_message += trans('challenge.confirm_request_public_text');

    if (!confirm(confirm_message)) {
        return;
    }


    challenge_state.sending_public_challenge_request = true;

    let data = {
        id_challenge: challenge_state.challenge.id_challenge
    };

    m.request({
        method: "POST",
        url: "/api/challenge/request_public",
        body: data
    }).then(function(data) {
        challenge_state.sending_public_challenge_request = false;
        challenge_state.can_request_public_challenge = false;
        challenge_state.public_challenge_requested = true;

        m.redraw();
    });
}

function getOrganizationTitle(org) {
    if (org.title && org.title != '')
        return org.title;

    return org.long_title;
}

function user_has_roles() {
    let has_roles = false;

    if (!challenge_state.id_user)
        return false;

    if (challenge_state.challenge.id_user == challenge_state.id_user)
        return true;

    if (has_permission('challenges.canInsertEntryToAnyone'))
        return true;

    if (challenge_state.challenge.roles.length == 0)
        return true;

    challenge_state.challenge.roles.forEach(role => {
        if (has_role(role.code, role.sports_constraints, role.regions_constraints)) {
            has_roles = true;
            return;
        }
    }); 

    return has_roles;
}

function reset_new_person_form() {
    challenge_state.new_person = {
        first_name: '',
        last_name: ''
    };
}

function reset_new_group_form() {
    challenge_state.new_group = {
        title: '',
        users: []
    };
    challenge_state.entry_user.list = [];
}

function reset_organization() {
    challenge_state.current_organization = null;
    challenge_state.selected_organizations = {
        list: []
    }

    if (has_permission('challenges.canInsertEntryToAnyone'))
        get_admin_entries();
}

function reset_entry_form() {
    // console.log("do reset!");

    if (challenge_state.challenge.entry_type_code == 'individual') {
        if (challenge_state.target_user_type == 'other') {
            challenge_state.entry_user.list = [];
        }
    }

    if (challenge_state.challenge.entry_type_code == 'group') {
        challenge_state.entry_group.list = [];
    }
}

function init(rootElement, id_challenge) {
    if (!rootElement) {
        return;
    }

    challenge_state.id_challenge = id_challenge;

    get_one_time_inputs();

    m.mount(rootElement, Challenge);
}

export default init;
